<!-- Ignore this part, it is only here to position drawer inside the example block -->
<div class="custom-portal"><ng-container #viewContainer /></div>

<!-- Debug Component for LocalStorage Testing -->


<header tuiNavigationHeader tuiTheme="theme" class="main-header">
  <div class="logo-align" [routerLink]="['/dashboard']">
    <img src="assets/logo/parking_icon.png" alt="Parking Icon" height="32">
    <!-- <img src="assets/logo/parking_logo.svg" alt="Parking Icon" height="16"> -->
    <span tuiFade>Create Parking</span>
  </div>
  <!-- <span tuiNavigationLogo>
    <span tuiFade>Create Parking</span>
  </span> -->
  <hr />
  <button appearance="secondary-grayscale"
    iconStart="@tui.save" tuiButton type="button"
    (click)="showSaveExitDialog()">
    Save & Exit
  </button>
</header>
<div [style.display]="'flex'">
  <!-- <app-shared-aside-navigation></app-shared-aside-navigation> -->
  <main tuiNavigationMain>

    <div class="aside-content-bottom-section">
      <div class="main-content">
        <div [style.grid-column]="'1 / span 3'">
          <tui-stepper orientation="vertical" [activeItemIndex]="getActiveStepperIndex()" size="s">
            <button *ngFor="let step of steps; let i = index" tuiStep (click)="onStepperClick(i)"
              class="stepper-container" [class._completed]="isStepperItemCompleted(i)"
              [class._active]="i === getActiveStepperIndex()" [class._last]="i === (steps.length - 1)">
              {{ step }}
            </button>
          </tui-stepper>
        </div>




        <!-- Step 1: Parking Type Section -->
        <div [style.grid-column]="'5 / span 6'" *ngIf="isStepActive(1)">

          <div class="main-content-header">
            <div class="top-section">
              <header tuiHeader="h4">
                <hgroup tuiTitle>
                  <h3>Let's start with your parking details</h3>
                  <p tuiSubtitle>Short titles work best. Make it recognizable – you can always change it later.</p>
                </hgroup>
              </header>
            </div>
          </div>
          <div class="sub-grid">
            <div [style.grid-column]="'span 12'">
              <div class="location-form-container" [style.padding.rem]=".5">
                <form [formGroup]="locationForm" tuiForm="m" (ngSubmit)="finalSubmit()" (keypress)="onKeyPress($event)">
                  <tui-textfield>
                    <label tuiLabel>Parking name *</label>
                    <input type="text" formControlName="parkingName" tuiTextfield />
                  </tui-textfield>
                  <tui-error formControlName="parkingName" [error]="[] | tuiFieldError | async" />

                  <tui-textfield>
                    <label tuiLabel>Describe your parking *</label>
                    <textarea placeholder="Enter your description" tuiTextarea formControlName="descriptionValue"
                      [max]="100" [min]="6"></textarea>
                  </tui-textfield>
                  <tui-error formControlName="descriptionValue" [error]="[] | tuiFieldError | async" />
                  <!-- <small class="input-des" [style.margin-top.rem]="'-.8'">
                    Share what makes your place special.
                  </small> -->
                </form>
              </div>
            </div>
          </div>

          <div class="main-content-header">
            <div class="top-section">
              <app-input-heading heading="Choose Parking Type" />
            </div>
          </div>

          <div class="sub-grid" [style.padding.rem]="'.5'" [style.margin-top.rem]="'.5'">
            <div [style.grid-column]="'span 4'" *ngFor="let type of parkingTypes; let i = index">
              <div class="step-flex-card-item">
                <div tuiAppearance="outline-grayscale" tuiCardLarge [class.active]="isCardActive(i)"
                  (click)="selectCard(i)">
                  <div class="out-side-icon">
                    <img [src]="type.icon" alt="{{ type.title }}" />
                  </div>
                  <h2 tuiTitle>
                    {{ type.title }}
                  </h2>
                </div>
              </div>
            </div>
          </div>


          <!-- Step 1 Navigation Buttons -->
          <button tuiButton type="button" appearance="primary" size="m" (click)="nextStep()" [style.width]="'100%'"
            [style.margin-top.rem]="1">
            Next
          </button>
          <!-- <button tuiButton type="button" appearance="flat" size="m" (click)="previousStep()" [style.width]="'100%'"
            [style.margin-top]="'.5rem'">
            Back
          </button> -->
        </div>

        <!-- Step 2: Enhanced Map Section -->
        <div [style.grid-column]="'5 / span 6'" *ngIf="isStepActive(2)">
          <div class="main-content-header">
            <div class="top-section">
              <header tuiHeader="h4">
                <hgroup tuiTitle>
                  <h3>Where's your parking located?</h3>
                  <p tuiSubtitle>Search for your location in {{ getOrganizationCountryName() }} or click on the map to
                    set your parking location.
                  </p>
                </hgroup>
              </header>
            </div>
          </div>
          <div class="sub-grid">
            <div [style.grid-column]="'span 12'">
              <div class="container-map">
                <!-- Enhanced Location Search Section -->
                <div class="location-search-section">
                  <div class="search-container">
                    <tui-textfield iconStart="@tui.map-pin">
                      <!-- <label tuiLabel>Search Location in {{ getCurrentCountryName() }}</label> -->
                      <!-- <tui-icon icon="@tui.map-pin" size="s"></tui-icon> -->
                      <input #searchInput [value]="searchQuery()" tuiTextfield
                        [placeholder]="'Search companies, malls, addresses, or landmarks in ' + getOrganizationCountryName()"
                        class="search-input" autocomplete="off" autocorrect="off" autocapitalize="off"
                        spellcheck="false" (focus)="onSearchInputFocus()" (blur)="onSearchInputBlur()"
                        (input)="onSearchInputChange($event)" [style.color]="'var(--tui-text-primary)'" />

                    </tui-textfield>



                    <!-- Organization Loading Display -->
                    <div class="organization-loading-display" *ngIf="isOrganizationLoading()">
                      <tui-icon icon="@tui.loader" size="s"></tui-icon>
                      <span>Loading organization details...</span>
                    </div>

                    <!-- Enhanced Search Results Dropdown -->
                    <div class="search-results-container" *ngIf="showSearchResults()">
                      <!-- Search Results -->
                      <div class="search-section">

                        <div class="search-results">
                          <div *ngFor="let result of searchResults()" class="search-result-item"
                            (mousedown)="selectSearchResult(result); $event.preventDefault()">
                            <div class="location-icon">
                              <!-- <tui-icon icon="@tui.map-pin" size="s"></tui-icon> -->
                              <tui-avatar src="@tui.map-pin" size="m" [style.border-radius]="'.75rem'" />
                            </div>
                            <div class="location-info">
                              <div class="primary-text">{{ result.structured_formatting?.main_text ||
                                result.description.split(',')[0] }}</div>
                              <div class="secondary-text">{{ result.description }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Loading State -->
                      <div class="search-loading" *ngIf="isSearching()">
                        <tui-icon icon="@tui.loader" size="s"></tui-icon>
                        <span>Searching...</span>
                      </div>

                      <!-- No Results -->
                      <div class="search-no-results"
                        *ngIf="!isSearching() && searchQuery() && searchResults().length === 0">
                        <tui-icon icon="@tui.search" size="s"></tui-icon>
                        <span>No results found for "{{ searchQuery() }}"</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Enhanced Map Section -->
                <section class="map-section">
                  <div class="map-container-wrapper">
                    <div #mapContainer class="map-container"></div>

                    <!-- Map Loading Indicator -->
                    <div class="map-loading" *ngIf="!isMapLoaded()">
                      <tui-icon icon="@tui.loader" size="m"></tui-icon>
                      <span>Loading map...</span>
                    </div>

                    <!-- Organization Country Display -->
                    <div class="map-reposition-display-drag">
                      <span>Drag the map to reposition the pin</span>
                    </div>
                  </div>
                </section>



                <header tuiHeader="h6">
                  <hgroup>
                    <p tuiSubtitle [style.color]="'var(--tui-text-primary)'" [style.margin-top.rem]="'1.5'"><b>Make sure
                        you have the precise location</b></p>
                    <p tuiSubtitle>The location will help user find your parking on various platform we partner with.
                      Also this might be used to track devices and authorized login for your team. Learn more</p>
                  </hgroup>
                </header>
              </div>
            </div>
          </div>
          <div style="display: flex; flex-direction: column; gap: .5rem; margin-top: 1rem;">
            <button tuiButton type="button" appearance="primary" size="m" (click)="nextStep()" [style.width]="'100%'"
              [disabled]="isReverseGeocoding()">
              <ng-container *ngIf="!isReverseGeocoding(); else geocodingTpl">Next</ng-container>
              <ng-template #geocodingTpl>
                <span class="flex" [style.align-items]="'center'" [style.gap.rem]=".25">
                  <tui-icon icon="@tui.loader" size="s"></tui-icon>
                  Fetching address...
                </span>
              </ng-template>
            </button>
            <button tuiButton type="button" appearance="flat" size="m" iconStart="@tui.arrow-left"
              (click)="previousStep()" [style.width]="'100%'">
              Back
            </button>
          </div>
        </div>

        <!-- Step 3: Form Details -->
        <div [style.grid-column]="'5 / span 6'" *ngIf="isStepActive(3)">
          <div class="main-content-header">
            <div class="top-section">
              <header tuiHeader="h4">
                <hgroup tuiTitle>
                  <h3>Complete your parking details</h3>
                  <p tuiSubtitle>Fill in the remaining information to complete your parking setup.
                  </p>
                </hgroup>
              </header>
            </div>
          </div>
          <div class="sub-grid">
            <div [style.grid-column]="'span 12'">
              <div class="location-form-container">
                <form [formGroup]="locationForm" tuiForm="m" (ngSubmit)="finalSubmit()" (keypress)="onKeyPress($event)">
                  <tui-textfield>
                    <label tuiLabel>Country/Region</label>
                    <input tuiTextfield formControlName="countryValue" value="{{ getOrganizationCountryName() }}"
                      readonly />
                  </tui-textfield>

                  <small class="input-des" [style.margin-top.rem]="'-.8'"
                    [style.opacity]="(locationForm.get('countryValue')?.errors && locationForm.get('countryValue')?.touched) ? 0 : 1">
                    Your organization default region is {{ getOrganizationCountryName() }}, you cant not change it.
                  </small>

                  <tui-textfield>
                    <label tuiLabel>Address</label>
                    <input formControlName="addressValue" tuiTextfield class="custom-small-input" />
                  </tui-textfield>
                  <tui-error formControlName="addressValue" [error]="[] | tuiFieldError | async" />

                  <tui-textfield>
                    <label tuiLabel>State/Province</label>
                    <input formControlName="stateValue" tuiTextfield class="custom-small-input" />
                  </tui-textfield>
                  <tui-error formControlName="stateValue" [error]="[] | tuiFieldError | async" />

                  <tui-textfield>
                    <label tuiLabel>City/Town</label>
                    <input formControlName="cityValue" tuiTextfield class="custom-small-input" />
                  </tui-textfield>
                  <tui-error formControlName="cityValue" [error]="[] | tuiFieldError | async" />

                  <tui-textfield>
                    <label tuiLabel>PIN Code</label>
                    <input formControlName="postalCodeValue" tuiTextfield class="custom-small-input" type="text" inputmode="numeric" pattern="[0-9]*" (input)="onOnlyNumbersInput($event, 'postalCodeValue')" (keypress)="onlyNumbers($event)" />
                  </tui-textfield>
                  <tui-error formControlName="postalCodeValue" [error]="[] | tuiFieldError | async" />

                  <app-input-heading heading="GEO-LOCATION"></app-input-heading>
                  <fieldset [style.margin-bottom]="'.5rem'">
                    <div class="stack">
                      <tui-textfield>
                        <label tuiLabel>Latitude</label>
                        <input formControlName="latitudeValue" tuiTextfield class="custom-small-input" />
                      </tui-textfield>
                      <tui-error formControlName="latitudeValue" [error]="[] | tuiFieldError | async" />
                    </div>
                    <div class="stack">
                      <tui-textfield>
                        <label tuiLabel>Longitude</label>
                        <input formControlName="longitudeValue" tuiTextfield />
                      </tui-textfield>
                      <tui-error formControlName="longitudeValue" [error]="[] | tuiFieldError | async" />
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <!-- Step 3 Navigation Buttons -->
          <button tuiButton type="button" appearance="primary" size="m" (click)="nextStep()" [style.width]="'100%'"
            [style.margin-top.rem]="1">
            Next
          </button>
          <button tuiButton type="button" appearance="flat" size="m" iconStart="@tui.arrow-left"
            (click)="previousStep()" [style.width]="'100%'" [style.margin-top]="'.5rem'">
            Back
          </button>
        </div>


        <!-- Step 4: Features & Amenities -->
        <div [style.grid-column]="'5 / span 6'" *ngIf="isStepActive(4)">
          <div class="main-content-header">
            <div class="top-section">
              <header tuiHeader="h4">
                <hgroup tuiTitle>
                  <h3>Tell guests what your parking has to offer</h3>
                  <p tuiSubtitle>Select the amenities and features available at your parking facility.</p>
                </hgroup>
              </header>
            </div>
          </div>
          <div class="sub-grid" [style.padding.rem]="'.5'">
            <div [style.grid-column]="'span 4'" *ngFor="let feature of parkingFeatures; let i = index">
              <div class="step-flex-card-item">
                <div tuiAppearance="outline-grayscale" tuiCardLarge [class.active]="isFeatureActive(i)"
                  (click)="selectFeature(i)">
                  <div class="out-side-icon">
                    <img [src]="feature.icon" alt="{{ feature.title }}" />
                  </div>
                  <h2 tuiTitle>
                    {{ feature.title }}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <!-- Step 4 Navigation Buttons -->
          <button tuiButton type="button" appearance="primary" size="m" (click)="nextStep()" [style.width]="'100%'"
            [style.margin-top.rem]="1">
            Next
          </button>

          <div class="skip">
            <button tuiButton type="button" appearance="flat" size="m" iconStart="@tui.arrow-left"
              (click)="previousStep()" [style.flex]="'1'" [style.margin-top]="'.5rem'">
              Back
            </button>
            <button *ngIf="canSkipStep()" tuiButton type="button" appearance="flat" size="m" iconEnd="@tui.arrow-right"
              (click)="skipStep()" [style.flex]="'1'" [style.margin-top]="'.5rem'">
              Skip
            </button>
          </div>
        </div>

        <!-- Step 5: Operating Hours -->
        <div [style.grid-column]="'5 / span 6'" *ngIf="isStepActive(5)">
          <div class="main-content-header">
            <div class="top-section">
              <header tuiHeader="h4">
                <hgroup tuiTitle>
                  <h3>Set your operating hours</h3>
                  <p tuiSubtitle>Define when your parking facility is available for bookings.</p>
                </hgroup>
              </header>
            </div>
          </div>
          <div class="sub-grid">
            <div [style.grid-column]="'span 12'">
              <div class="location-form-container">
                <form [formGroup]="locationForm" tuiForm="m" (ngSubmit)="finalSubmit()" (keypress)="onKeyPress($event)">
                  <!-- Timezone: dropdown if multiple; read-only if single -->
                  <ng-container
                    *ngIf="hasMultipleTimezones && timezonesForSelectedCountry.length > 0; else singleTimezone">
                    <tui-textfield tuiChevron [tuiTextfieldCleaner]="false">
                      <label tuiLabel>Time Zone</label>
                      <input formControlName="timeZoneValue" tuiSelect />
                      <tui-data-list-wrapper *tuiTextfieldDropdown new [items]="timezonesForSelectedCountry" />
                    </tui-textfield>
                  </ng-container>
                  <ng-template #singleTimezone>
                    <tui-textfield>
                      <label tuiLabel>Time Zone</label>
                      <input formControlName="timeZoneValue" tuiTextfield [readOnly]="true" />
                    </tui-textfield>
                  </ng-template>
                  <tui-error formControlName="timeZoneValue" [error]="[] | tuiFieldError | async" />
                  <small class="input-des" [style.margin-top.rem]="'-.8'">
                    Timezone is based on region defined by admin.
                  </small>

                  <div tuiAppearance="outline-grayscale" tuiCardLarge [style.border-radius]="'.75rem'">
                    <label tuiCell [style.padding]="'.5rem'" [style.padding-top]="'0rem'"
                      [style.background-color]="'transparent'">
                      <div tuiTitle class="flex">
                        <p>All day open:</p>
                        <b>{{locationForm.get('allDay')?.value ? 'Yes' : 'No'}}</b>
                      </div>
                      <input tuiSwitch type="checkbox" formControlName="allDay" size="m" />
                    </label>

                    <div class="days-container" *ngIf="!locationForm.get('allDay')?.value">
                      <div class="day-container" [class.selected]="locationForm.get('monday')?.value"
                        (click)="toggleDay('monday')">
                        <p>Mo</p>
                      </div>
                      <div class="day-container" [class.selected]="locationForm.get('tuesday')?.value"
                        (click)="toggleDay('tuesday')">
                        <p>Tu</p>
                      </div>
                      <div class="day-container" [class.selected]="locationForm.get('wednesday')?.value"
                        (click)="toggleDay('wednesday')">
                        <p>We</p>
                      </div>
                      <div class="day-container" [class.selected]="locationForm.get('thursday')?.value"
                        (click)="toggleDay('thursday')">
                        <p>Th</p>
                      </div>
                      <div class="day-container" [class.selected]="locationForm.get('friday')?.value"
                        (click)="toggleDay('friday')">
                        <p>Fr</p>
                      </div>
                      <div class="day-container" [class.selected]="locationForm.get('saturday')?.value"
                        (click)="toggleDay('saturday')">
                        <p>Sa</p>
                      </div>
                      <div class="day-container" [class.selected]="locationForm.get('sunday')?.value"
                        (click)="toggleDay('sunday')">
                        <p>Sun</p>
                      </div>
                    </div>
                  </div>

                  <div tuiAppearance="outline-grayscale" tuiCardLarge [style.border-radius]="'.75rem'">
                    <label tuiCell [style.padding]="'.5rem'" [style.padding-top]="'0rem'"
                      [style.background-color]="'transparent'">
                      <div tuiTitle class="flex">
                        <p>Open 24 hours:</p>
                        <b>{{locationForm.get('open24Hours')?.value ? 'Yes' : 'No'}}</b>
                      </div>
                      <input tuiSwitch type="checkbox" formControlName="open24Hours" size="m" />
                    </label>

                    <div class="time-container" *ngIf="!locationForm.get('open24Hours')?.value">
                      <div class="stack">
                        <tui-textfield>
                          <label tuiLabel>Open Time</label>
                          <input tuiInputTime type="time" formControlName="openTimeValue" mode="HH:MM AA" />
                        </tui-textfield>
                      </div>
                      <div class="stack">
                        <tui-textfield>
                          <label tuiLabel>Close Time</label>
                          <input tuiInputTime type="time" formControlName="closeTimeValue" mode="HH:MM AA" />
                        </tui-textfield>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- Step 6 Navigation Buttons (show loader while uploading) -->
          <button tuiButton type="button" appearance="primary" size="m" (click)="nextStep()" [disabled]="isSubmitting()"
            [style.width]="'100%'" [style.margin-top.rem]="1.5">
            <ng-container *ngIf="!isSubmitting(); else uploadingTpl">Next</ng-container>
          </button>
          <ng-template #uploadingTpl>
            <span class="flex" [style.align-items]="'center'" [style.gap.rem]=".25">
              <tui-icon icon="@tui.loader" size="s"></tui-icon>
              Uploading...
            </span>
          </ng-template>
          <button tuiButton type="button" appearance="flat" size="m" iconStart="@tui.arrow-left"
            (click)="previousStep()" [style.width]="'100%'" [style.margin-top]="'.5rem'">
            Back
          </button>
        </div>

        <!-- Step 6: Parking Images -->
        <div [style.grid-column]="'5 / span 6'" *ngIf="isStepActive(6)">

          <div class="main-content-header">
            <div class="top-section">
              <header tuiHeader="h4">
                <hgroup tuiTitle>
                  <h3>Bring Your Parking to Life</h3>
                  <p tuiSubtitle>Upload clear entry photos, signage, and layout images to help visitors find and
                    navigate your parking effortlessly. Great visuals make parking seamless and trustworthy.</p>
                </hgroup>
              </header>
            </div>
          </div>


          <label tuiInputFiles [style.margin-top.rem]="1" [style.margin-bottom.rem]=".3" data-no-auto-translate="true"
            translate="no">
            <input #validator="tuiInputFilesValidator" accept="image/*" tuiInputFiles [formControl]="fileControl"
              [multiple]="true" (reject)="onReject($event)" />
          </label>
          <small class="input-des">
            Add visuals related to the facility (optional). JPEG, PNG, WebP support only. Maximum 5 files ({{
            getTotalFilesCount() }}/5).
          </small>

          <!-- Existing Images + New Files Display Combined -->
          <div class="file-cards-container" [style.margin-top.rem]="1">
            <!-- Existing images -->
            <div *ngFor="let image of existingImages; let i = index" class="file-card"
              (click)="openExistingImagePreview(i)">
              <div class="file-card-content">
                <div class="file-thumbnail">
                  <img [src]="image" alt="Existing image" class="file-preview-image" />
                </div>
                <button type="button" class="file-remove-btn"
                  (click)="onRemoveExistingImage(i); $event.stopPropagation()" title="Remove image">
                  ×
                </button>
              </div>
            </div>

            <!-- Newly uploaded files -->
            <ng-container *ngIf="accepted$ | async as acceptedFiles">
              <div *ngFor="let file of acceptedFiles; let i = index" class="file-card" (click)="openFilePreview(i)">
                <div class="file-card-content">
                  <div class="file-thumbnail">
                    <img *ngIf="isImageFile(file)" [src]="getFileUrl(file)" [alt]="file.name"
                      class="file-preview-image" />
                    <div *ngIf="!isImageFile(file)" class="file-icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                        <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                        <polyline points="10,9 9,9 8,9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                  <button type="button" class="file-remove-btn" (click)="onRemove(file); $event.stopPropagation()"
                    title="Remove file">
                    ×
                  </button>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Error files display -->
          <div *ngIf="rejected.length > 0" class="file-cards-container">
            <div *ngFor="let file of rejected" class="file-card error">
              <div class="file-card-content">
                <div class="file-thumbnail">
                  <div class="file-icon error">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                      <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2" />
                      <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2" />
                    </svg>
                  </div>
                </div>
                <button type="button" class="file-remove-btn" (click)="onRemove(file); $event.stopPropagation()"
                  title="Remove file">
                  ×
                </button>
              </div>
            </div>
          </div>

          <!-- Step 6 Navigation Buttons -->
          <button tuiButton type="button" appearance="primary" size="m" (click)="nextStep()" [style.width]="'100%'"
            [style.margin-top.rem]="1.5">
            Next
          </button>

          <div class="skip">
            <button tuiButton type="button" appearance="flat" size="m" iconStart="@tui.arrow-left"
              (click)="previousStep()" [style.flex]="'1'" [style.margin-top]="'.5rem'">
              Back
            </button>
            <button *ngIf="canSkipStep()" tuiButton type="button" appearance="flat" size="m" iconEnd="@tui.arrow-right"
              (click)="skipStep()" [style.flex]="'1'" [style.margin-top]="'.5rem'">
              Skip
            </button>
          </div>
        </div>


        <!-- Step 6: Team Selection -->
        <div [style.grid-column]="'5 / span 6'" *ngIf="isStepActive(7)">
          <div class="main-content-header">
            <div class="top-section">
              <header tuiHeader="h4">
                <hgroup tuiTitle>
                  <h3>Who manages this parking?</h3>
                  <p tuiSubtitle>Assign a team member or vendor to handle day-to-day operations like bookings, customer
                    queries, and access control.</p>
                </hgroup>
              </header>
            </div>
          </div>
          <div class="sub-grid" [style.padding.rem]="'0'">
            <div [style.grid-column]="'span 12'">
              <div class="location-form-container">
                <div class="parking-type-card-form">
                  <form [formGroup]="locationForm" [style.max-width]="'100%'" tuiForm="l">
                    <!-- Team selection form -->
                  </form>

                  <!-- Custom Dropdown with Custom List -->
                  <div class="flex-row-gap-1">
                    <tui-select class="control" tuiTextfieldSize="s" [(ngModel)]="selectedTeamDisplayValue"
                      [(tuiDropdownOpen)]="teamSelectOpen" [ngModelOptions]="{standalone: true}"
                      [style.z-index]="'9999'" [style.flex]="1">
                      Select team member
                      <custom-list #teamList *tuiDataList [items]="teamItems" (addTeamClick)="onAddTeamFromDropdown()"
                        (userSelected)="onUserSelected($event)" [style.z-index]="'9999'" />
                    </tui-select>

                    <!-- <button tuiButton type="button" appearance="secondary" size="m" (click)="onAddTeamFromDropdown()"
                      iconStart="@tui.plus" [style.white-space]="'nowrap'">
                      Invite New
                    </button> -->
                  </div>

                  <small class="input-des" [style.opacity]="1" [style.margin-top]="'-0.5rem'">
                    You can also manage permissions in Team Module.
                  </small>

                  <tui-notification size="m" appearance="warning" icon="@tui.info" [style.margin-top]="'1rem'">
                    The assigned person will have full permissions to manage this parking lot, including editing prices,
                    facilities, passes, and operating rules.
                  </tui-notification>

                </div>
              </div>
            </div>

            <!-- Team Invite Drawer -->
            <app-drawer-invite-team-member #teamDrawerComponent [showParkingDropdown]="false"
              [showPermissions]="isEditMode && currentStep() !== 7" [stepType]="'parking-manager'"
              (teamMembersCreated)="onTeamMembersCreated($event)">
            </app-drawer-invite-team-member>
          </div>

          <!-- Step 6 Navigation Buttons -->
          <button tuiButton type="button" appearance="primary" size="m" (click)="nextStep()" [style.width]="'100%'">
            Next
          </button>
          <button tuiButton type="button" appearance="flat" size="m" iconStart="@tui.arrow-left"
            (click)="previousStep()" [style.width]="'100%'" [style.margin-top]="'.5rem'">
            Back
          </button>
        </div>

        <!-- Step 7: Review and Submit -->
        <div [style.grid-column]="'5 / span 6'" *ngIf="isStepActive(8)">
          <div [style.grid-column]="'1 / span 12'">
            <header tuiHeader="h4">
              <hgroup tuiTitle class="left">
                <h3>Review and go live with your parking.</h3>
                <p tuiSubtitle>
                  Thats it. 
                  <!-- <button tuiLink type="button" [style.text-decoration-line]="'underline'"
                    [textContent]="'Learn more'"></button> -->
                </p>
              </hgroup>
            </header>
            <div class="review-parking-card">
              <div class="review-parking-card-item">
                <!-- <section class="accordion-item-section" tuiCardLarge="compact" [tuiCardCollapsed]="isSectionCollapsed(group.key)"
                    tuiAppearance="outline-grayscale" [style.gap]="'0.5rem'" [style.margin-block-end]="'0rem'" [style.margin-bottom]="'1rem'"
                    *ngFor="let group of operations | keyvalue: orderBy">
                    <header tuiHeader="body-m" class="accordion-header"> 
                      <tui-avatar [style.background-color]="'#171E27'" [src]="group.value[0].icon" size="m"
                        [style.border-radius]="'0.75rem'" />
                      <hgroup tuiTitle iconStart="@tui.info" class="left">
                        <h2>{{ group.key }}</h2>
                      </hgroup>
                      <aside tuiAccessories>
                        <button appearance="secondary" size="s" tuiIconButton type="button"
                          [tuiChevron]="!isSectionCollapsed(group.key)" (click)="toggleSection(group.key)"
                        >
                          Expand
                        </button>
                      </aside>
                    </header>

                    <tui-expand [expanded]="!isSectionCollapsed(group.key)"
                      [style.padding]="'0'" [style.background-color]="'transparent'">
                      <div class="review-parking-card-item-content" *ngFor="let item of group.value">
                        <div *ngIf="item.name">Name: {{ item.name }}</div>
                        <div *ngIf="item.parkingType">Parking Type: {{ item.parkingType }}</div>
                        <div *ngIf="item.location">Location: {{ item.location }}</div>
                        <div *ngIf="item.amenities">Amenities: {{ item.amenities }}</div>
                        <div *ngIf="item.operations">Operations: {{ item.operations }}</div>
                        <div *ngIf="item.vehicleTypes">Vehicle Types: {{ item.vehicleTypes }}</div>
                        <div *ngIf="item.facilities">Facilities: {{ item.facilities }}</div>
                        <div *ngIf="item.manager">Manager: {{ item.manager }}</div>
                      </div>
                    </tui-expand>
                  </section> -->
                <div class="parking-info-card">
                  <div class="info-row">
                    <span class="info-label">Parking Type:</span>
                    <span class="info-value">{{ parkingData.parkingType || '-' }}</span>
                  </div>

                  <div class="info-row">
                    <span class="info-label">Location:</span>
                    <span class="info-value">{{ parkingData.parkingAddress || '-' }}</span>
                  </div>

                  <div class="info-row">
                    <span class="info-label">Parking Name:</span>
                    <span class="info-value">{{ parkingData.parkingName || '-' }}</span>
                  </div>

                  <div class="info-row description-row">
                    <span class="info-label">Description:</span>
                    <div class="info-value description-content">
                      <span #descText [class.clamp-4]="!isDescriptionExpanded">
                        {{ parkingData.description || '-' }}
                      </span>
                      <button *ngIf="showReadMore" class="read-more-btn" tuiLink type="button"
                        (click)="toggleDescription()" [textContent]="isDescriptionExpanded ? 'Read less' : 'Read more'"
                        [style.text-decoration-line]="'underline'"></button>
                    </div>
                  </div>

                  <div class="info-row">
                    <span class="info-label">Amenities:</span>
                    <span class="info-value">{{ parkingData.amenities || '-' }}</span>
                  </div>

                  <div class="info-row">
                    <span class="info-label">Operations:</span>
                    <span class="info-value">{{ parkingData.operatingHours || '-' }}</span>
                  </div>

                  <!-- <div class="info-row">
                    <span class="info-label">Facilities:</span>
                    <span class="info-value">{{ parkingData.facilities || '-' }}</span>
                  </div> -->

                  <div class="info-row">
                    <span class="info-label">Managed by:</span>
                    <span class="info-value">{{ parkingData.manager || '-' }} • {{ parkingData.managedBy || '-' }}</span>
                  </div>
                </div>


              </div>
              <div class="review-parking-card-item card-i">

                <div class="wrapper">
                  <tui-push tuiTheme="dark" [style.padding]="'0'">
                    <div class="carousel-container">
                      <tui-carousel [duration]="4000" [(index)]="index" (indexChange)="onCarouselIndexChange($event)">
                        <ng-container *ngFor="let item of carouselItems">
                          <div *tuiItem class="carousel-item">
                            <img [src]="item.src" [alt]="item.title" class="carousel-image" />
                          </div>
                        </ng-container>
                      </tui-carousel>

                      <button *ngIf="carouselItems.length > 1" tuiIconButton type="button" iconStart="@tui.chevron-left"
                        appearance="custom" shape="rounded" size="xs" class="carousel-nav prev"
                        (click)="navigateCarousel(-1, $event)"></button>
                      <button *ngIf="carouselItems.length > 1" tuiIconButton type="button"
                        iconStart="@tui.chevron-right" appearance="custom" shape="rounded" size="xs"
                        class="carousel-nav next" (click)="navigateCarousel(1, $event)"></button>

                      <tui-pagination size="s" class="pagination" [length]="carouselItems.length" [(index)]="index" />
                    </div>

                    <div class="carousel-content-container">
                      <div class="calendar-icon-container">
                        <tui-icon icon="@tui.calendar" [style.color]="'var(--tui-text-action)'" size="s" />
                        <span class="calendar-text">{{ parkingData.operatingHours || 'All day • 24 Hours' }}</span>
                      </div>
                      <p><b>{{ parkingData.parkingName || 'Parking Name' }}</b></p>
                      <span>{{ parkingData.parkingAddress || 'Parking Address' }}</span>
                      <div class="icon-container">
                        <ng-container *ngFor="let svg of amenitySvgs()">
                          <span class="amenity-svg" [innerHTML]="svg"></span>
                        </ng-container>
                      </div>
                    </div>
                  </tui-push>
                </div>

              </div>
            </div>

            <div class="terms-and-conditions">
              <h3 [style.margin-bottom]="'.5rem'">Terms and Conditions</h3>
              <p>By continuing, you confirm that you’ve read and agree to the <a
                  href="https://sistem.app/working-with-parking-sistem-app/" target="_blank" tuiLink type="button"
                  [style.text-decoration-line]="'underline'"
                  [textContent]="'terms of services, parking host policies'"></a> for
                parking locations. 
              <p [style.margin-top]="'.5rem'">By selecting “I agree”, you confirm that:</p>
              <ul>
                <li>You have the necessary licences and permissions to operate this parking space.</li>
                <li>You agree to follow all local laws and our platform standards.</li>
                <li>You’ll maintain safety, cleanliness, and accurate rate listings.</li>
                <li>You’ll ensure your facility meets any legal and accessibility requirements.</li>
              </ul>
            </div>
          </div>
          <!-- <span>By clicking the button I agree to </span>
             <button tuiLink type="button" [style.text-decoration-line]="'underline'"
              [textContent]="'Sistem Listing Terms'"></button>
            &nbsp;&nbsp; &nbsp;&nbsp; 
            -->
          <br><br>

          <!-- Step 7 Navigation Buttons -->
          <div class="footer-section-right">

            <button tuiButton type="button" appearance="primary" size="m" (click)="goLiveWithParking()"
              [disabled]="isActivating()" [style.width]="'100%'">
              <span *ngIf="!isActivating()">Go live with your parking, now</span>
              <span *ngIf="isActivating()">Activating...</span>
            </button>
          </div>

          <div class="terms-and-conditions-bottom">
            <span>By clicking the button I agree to </span>
            <a href="https://sistem.app/privacy-policy/" target="_blank" tuiLink type="button"
              [style.text-decoration-line]="'underline'" [textContent]="'Sistem Listing Terms'"></a>
          </div>


          <!-- <button tuiButton type="button" appearance="flat" size="m" (click)="previousStep()" [style.width]="'100%'"
            [style.margin-top]="'.5rem'">
            Back
          </button> -->
        </div>
      </div>
    </div>


    <!-- preview modal -->
    <ng-template #preview let-preview>
      <tui-preview [initialScale]="1.0" [rotatable]="true" (tuiSwipe)="onSwipe($event)">
        <tui-preview-title>{{ getCurrentFileName() }}</tui-preview-title>
        <tui-preview-pagination [length]="getUploadedFilesLength()" [(index)]="previewIndex" />

        <!-- <button iconStart="@tui.trash" tuiIconButton tuiPreviewAction type="button" (click)="deleteCurrentFile()">
          Delete
        </button>
        <button iconStart="@tui.download" tuiIconButton tuiPreviewAction type="button" (click)="downloadCurrentFile()">
          Download
        </button> -->
        <button iconStart="@tui.x" tuiIconButton tuiPreviewAction type="button" (click)="preview.complete()">
          Close
        </button>

        <img [src]="getCurrentFileUrl()" alt="preview" style="width: 100%; height: 100%; min-width: 280px; min-height: 280px; max-width: 80vw; max-height: 80vh; object-fit: contain;" />
      </tui-preview>
    </ng-template>

    <ng-template #contentSample>
      <div class="content">
        <h1>Important document</h1>

        <p>Hello everyone! This is some important document in A4 format, although it is made using html</p>

        <p>
          This shows that the component preview can work with absolutely any content: this way you can show any
          template, image, pdf or even iframe with your favorite site. We will put this content in the center of the
          portal and provide the user with control over it, and we will provide you with convenient levers to change
          it and process actions.
        </p>

        <img alt="logo"
          src="https://raw.githubusercontent.com/taiga-family/ng-polymorpheus/main/projects/demo/assets/logo.svg"
          class="polymorpheus" />
      </div>
    </ng-template>
  </main>
</div>